<div class="wrapper">
  <canvas
    #canvas
    id="signature-pad"
    class="signature-pad"
    [width]="signaturePadOptions.canvasWidth"
    [height]="signaturePadOptions.canvasHeight"
  ></canvas>
</div>
<processing-buttons [cancelButtonTitle]="cancelButtonTitle"
                    [continueButtonTitle]="continueButtonTitle"
                    [showCancelButton]="showCancelButton"
                    [showContinueButton]="showContinueButton"
                    (onCancel)="clearPad()"
                    (onContinue)="getSignatureAndFinish()"
></processing-buttons>
